<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @doClear="initFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="repairWorkOrderResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" editDisable
                                      with-custom-row-actions-first-column>
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button type="task"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="$_emWorkflowListMixin_handleApprove(row)">
                                        </em-button>

                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-icon="fa fa-fw fa-lg fa-link"
                                                   custom-label="选择当前维修工单需要领用的备件"
                                                   @click="popSpa(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-window-close"
                                               :disabled="actionDisabledDel('select')"
                                               custom-label="删除设备维修工单"
                                               :showName="true"
                                               v-show="judgeRouterStatus"
                                               confirm-text="确定要删除勾选的工单吗？"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="deleteWorkOrder()">
                                    </em-button>

                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <sub-entity-list ref="spaEntityList" sub-entity="emSppRequisitionRwoSrr"
                         parent-field="srrIdRwo"></sub-entity-list>

    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-12-05 19:24:22
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import subEntityList from "@/components/em/EmModal/SubEntityList";
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "repairWorkOrderWorkflowListView",
    mixins: [emWorkflowListMixin, emCommonApiMixin],
    components: {subEntityList},
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        judgeRouterStatus() {
            return !(this.$_emWorkflowListMixin_pathType === "todo" || this.$_emWorkflowListMixin_pathType === "wait");
        }
    },
    methods: {
        popSpa(row) {
            this.$refs.spaEntityList.showModal(row.id);
        },
        actionDisabledDel(type) {

            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        deleteWorkOrder() {
            let self = this;
            if (self.selectIds) {
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/deleteWorkOrder?ids=${self.selectIds}`
                self.$_emApiMixin_post(url, {})
                    .then(request => {
                        if (request.status === 200) {
                            //console.log(request)
                            self.$message({
                                message: "删除成功，" + request.data,
                                type: "success",
                            });
                            self.$refs["emListFilter"].doQuery()
                        } else {
                            self.$message({
                                message: "删除失败",
                                type: "error",
                            });
                        }

                    })
            }
        },
        initFilter() {
            //清除设备档案跳转绑定的查询条件，清除按钮无法清空的问题
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('rwoCodeBdaFilter', null);
        }
    }
};
</script>